module.exports = __webpack_public_path__ + "img/concrete-transitions.548ae53a.png";